<template>
  <div class="modal fade" id="modalProduct" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{this.modalName}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body text-center">
          <p>{{ this.modalDescription }}</p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>

export default {
  name: 'ProductModal',
  components: {
  },
  props: {
    modalName: String,
    modalDescription: String,
  },
  mounted () {
  }
}

</script>

<style scoped>

#modalProduct {
  font-family: Montserrat Regular;
}

.modal-body {
  padding: 30px;
}

.modal-title {
  font-weight: bold;
}

.modal-footer button {
  padding: 4px 10px;
  font-size: 16px;
  background-color: #323232;
  border-color: #323232;
}

.btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
}

</style>